// Lazy Image
(function() {
class ImageSrcSet extends HTMLElement {
  get intersecting() {
    return this.hasAttribute('intersecting');
  }  
  constructor() {
    super();
    this.img = this.querySelectorAll('img');
    this.productSlide = this.closest('.product-image-main .swiper-slide');
    this.slideLoadFrame = null;
    this.observerCallback = this.observerCallback.bind(this);
    this.loadImage = this.loadImage.bind(this);
    this.slideObserverCallback = this.slideObserverCallback.bind(this);
    this.img.forEach(item => item.onload = this.onLoad.bind(this))
  }
  connectedCallback() {
    if (this.productSlide) this.initSlideObserver();
    if ('IntersectionObserver' in window) this.initIntersectionObserver();else this.loadImage();
  }
  disconnectedCallback() {
    this.cancelSlideLoad();
    this.disconnectObserver();
    this.disconnectSlideObserver();
  }
  loadImage() {
    if (this.intersecting) return;
    this.setAttribute('intersecting', 'true');
    this.img.forEach(item => {
        item.width = this.clientWidth;
        item.height = this.clientHeight;
        item.sizes = this.clientWidth + 'px';
        if (item.dataset.srcset) {
          item.srcset = item.dataset.srcset;
          delete item.dataset.srcset;
        }
        if (item.dataset.src) {
          item.src = item.dataset.src;
          delete item.dataset.src;
        }
    })
    this.img.forEach(item => {
        item.classList.add('res-img-loaded');
    })
  }
  onLoad() {
    this.removeAttribute('data-image-loading');
  }
  observerCallback(entries, observer) {
    if (!entries[0].isIntersecting) return;
    const hasEagerImage = Array.from(this.img).some(item => item.loading === 'eager');
    if (this.productSlide && !this.productSlide.classList.contains('swiper-slide-active') && !hasEagerImage) return;
    observer.unobserve(this);
    this.loadImage();
  }
  slideObserverCallback() {
    this.cancelSlideLoad();
    this.slideLoadFrame = requestAnimationFrame(() => {
      this.slideLoadFrame = null;
      if (!this.productSlide.classList.contains('swiper-slide-active')) return;
      this.disconnectObserver();
      this.disconnectSlideObserver();
      this.loadImage();
    });
  }
  cancelSlideLoad() {
    if (this.slideLoadFrame === null) return;
    cancelAnimationFrame(this.slideLoadFrame);
    this.slideLoadFrame = null;
  }
  initSlideObserver() {
    if (this.slideObserver) return;
    this.slideObserver = new MutationObserver(this.slideObserverCallback);
    this.slideObserver.observe(this.productSlide, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
  disconnectSlideObserver() {
    if (!this.slideObserver) return;
    this.slideObserver.disconnect();
    this.slideObserver = null;
    delete this.slideObserver;
  }
  initIntersectionObserver() {
    if (this.observer) return;
    const rootMargin = '10px';
    this.observer = new IntersectionObserver(this.observerCallback, {
      rootMargin
    });
    this.observer.observe(this);
  }
  disconnectObserver() {
    if (!this.observer) return;
    this.observer.disconnect();
    this.observer = null;
    delete this.observer;
  }
}
customElements.define('image-srcset', ImageSrcSet);
})();
